import { createFileRoute } from '@tanstack/react-router';
import OrdersManagement from '../../../components/manager/OrdersManagement';

export const Route = createFileRoute('/staff/orders/')({
  component: StaffOrdersIndex,
});

function StaffOrdersIndex() {
  return <OrdersManagement />;
}
